import { connect, WalletConnection, Contract } from "near-api-js";
import { getConfig } from "./config";
import cookie from "react-cookies";
import axios from "axios";
import instance, { setAuthToken } from "./axios";
import { toast } from "react-toastify";

let wallet = null;
connect(getConfig('mainnet')).then(
  (near) => (wallet = new WalletConnection(near, null))
);
export const login = async () => {
  connect(getConfig('mainnet')).then(async (near) => {
    wallet = new WalletConnection(near, null);
    wallet.requestSignIn();
  });
};

export const isSignedIn = async () => {
  if (!Boolean(wallet && wallet.isSignedIn())) {
    return 0;
  }
  const accountId = wallet.getAccountId();
  const contractId = process.env.REACT_APP_CONTRACT_ID;
  const nft = await axios.post("/api/contract/getNFT", {
    contractId,
    accountId,
  });
  if (nft.data === "") return 1;
  const {
    title,
    description,
    media,
    user_type: userType,
    organization,
  } = nft.data.metadata;
  cookie.save(
    "user",
    {
      tokenId: Number(nft.data.token_id),
      walletId: nft.data.owner_id,
      title,
      description,
      media,
      userType,
      organization,
    },
    { path: "/" }
  );
  localStorage.setItem("accessToken", nft.data.accessToken);
  setAuthToken(nft.data.accessToken);
  if (cookie.load("user")?.organization.toLowerCase() !== "gyde") {
    window.location.assign(`/organization/${cookie.load("user").organization}`);
  } else {
    window.location.reload();
  }
  return 2;
};

export const checkLogin = async () => {
  const result = await isSignedIn();
  if (result === 0) {
    toast.error(
      <span>
        Wallet not connected
        <br />
        Connect your wallet to login
      </span>
    );
  } else if (result === 1)
    toast.error(
      <span>
        No Valid NFT found
        <br />
        Please Sign Up first
      </span>
    );
  else if (result === 2) return;
};

export const mintNFT = async (val) => {
  const contract = new Contract(
    wallet.account(),
    process.env.REACT_APP_CONTRACT_ID,
    {
      viewMethods: [],
      changeMethods: ["nft_mint"],
      sender: wallet,
    }
  );
  const result = await instance.post("/api/contract/getAllNFTCount", {
    contractId: process.env.REACT_APP_CONTRACT_ID,
  });
  const tokenId = Number(result.data.length + 1);
  try {
    await contract.nft_mint({
      args: {
        token_id: `${tokenId}`,
        metadata: {
          title: val.title,
          description: val.description,
          media: val.media,
          user_type: val.userType,
          organization: val.organization,
        },
        receiver_id: val.accountId,
      },
      gas: "300000000000000",
      amount: "10000000000000000000000",
    });
    return true;
  } catch (error) {
    toast.error(error);
    return false;
  }
};

export const modifyNFT = async (val) => {
  const contract = new Contract(
    wallet.account(),
    process.env.REACT_APP_CONTRACT_ID,
    {
      viewMethods: [],
      changeMethods: ["nft_modify_token"],
      sender: wallet,
    }
  );
  await contract
    .nft_modify_token({
      args: {
        token_id: val.tokenId,
        metadata: {
          title: val.title,
          description: val.description,
          media: val.media,
          userType: val.userType,
          organization: val.organization,
        },
      },
      gas: "300000000000000",
    })
    .catch((error) => toast.error(error));
};

export const logout = () => {
  wallet && wallet.signOut();
};
